import { Box, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  borderColor?: {
    dark: string;
    light: string;
  };
};

export const MessageBox = ({
  children,
  borderColor: borderColorProp,
}: PropsWithChildren<Props>) => {
  const theme = useTheme();
  const borderColor = borderColorProp || {
    dark: 'var(--color-grey-medium)',
    light: 'var(--color-grey)',
  };
  return (
    <Box
      sx={{
        border: '2px solid',
        borderColor:
          theme.palette.mode === 'dark' ? borderColor.dark : borderColor.light,
        borderRadius: '2px 0 0 2px',
        borderLeftWidth: '6px',
        p: '1.125rem 1rem',
      }}
    >
      {children}
    </Box>
  );
};
